// extracted by mini-css-extract-plugin
export default {"errors-container":"classes_errors-container__7sJxl","errors":"classes_errors__Qlh9W"};